import type { BrushDefinition } from "./brushTypes";

export const markerBrush: BrushDefinition = {
  tool: "marker",
  label: "Marker",
  widthMultiplier: 1.65,
  baseOpacity: 0.58,
  interpolationSpacing: 0.18,
  pressureSensitive: false,
  texture: "marker",
};
